import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import VisitsListItem from './VisitsListItem';

const VisitsListTable = props => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead color="primary">
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Nombre del aplicante</TableCell>
            <TableCell>Teléfono</TableCell>
            <TableCell>Fecha</TableCell>
            <TableCell>Compañía</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell align="center" sx={{ verticalAlign: 'middle' }}>Informe</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.requirements?.map(requirement => <VisitsListItem key={requirement.objectId} {...requirement} onDownloadClick={props.onDownloadClick}/>)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default VisitsListTable;
